import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createBrowserRouter, RouterProvider, type RouteObject } from "react-router-dom";
import Shell from "./components/Shell";
import Agents from "./pages/Agents";
import Approval from "./pages/Approval";
import Companies from "./pages/Companies";
import Company from "./pages/Company";
import Digests from "./pages/Digests";
import Document from "./pages/Document";
import Documents from "./pages/Documents";
import Home from "./pages/Home";
import Monitors from "./pages/Monitors";
import Operations from "./pages/Operations";
import Portfolio from "./pages/Portfolio";
import Research from "./pages/Research";
import NotFound from "./pages/NotFound";
import Watchlists from "./pages/Watchlists";
import { SessionProvider } from "./lib/session";

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } },
});

// basename /app: locked path convention (RECONCILIATION §1) — works under the
// interim ALB rules and unchanged after the default-action flip.
export const portalRoutes: RouteObject[] = [
    {
      path: "/",
      element: <Shell />,
      children: [
        { index: true, element: <Home /> },
        { path: "research", element: <Research /> },
        { path: "research/:historyArtifactId/history", element: <Research /> },
        { path: "research/:artifactId", element: <Research /> },
        { path: "agents", element: <Agents /> },
        { path: "monitors", element: <Monitors /> },
        { path: "companies", element: <Companies /> },
        { path: "companies/:companyRef", element: <Company /> },
        { path: "documents", element: <Documents /> },
        { path: "documents/:documentId", element: <Document /> },
        { path: "watchlists", element: <Watchlists /> },
        { path: "digests", element: <Digests /> },
        { path: "portfolio", element: <Portfolio /> },
        { path: "operations", element: <Operations /> },
        { path: "approvals/:id", element: <Approval /> },
        { path: "*", element: <NotFound /> },
      ],
    },
  ];

const router = createBrowserRouter(
  portalRoutes,
  { basename: "/app" },
);

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <RouterProvider router={router} />
      </SessionProvider>
    </QueryClientProvider>
  );
}
